import * as urlUtils from 'utils/Url';


export function getPathContacts(qs={}) {
  return urlUtils.appendQueryString(`/contacts`, qs);
}

export function getPathNonSendableContacts(qs={}) {
  return urlUtils.appendQueryString(`/non-sendable-contacts`, qs);
}

export function getPathSuppressedContacts(qs={}) {
  return urlUtils.appendQueryString(`/suppressed-contacts`, qs);
}

export function getPathAddContact() {
  return `/contacts/add`;
}

export function getPathEditContact(contactId) {
  return `/contacts/${contactId}/edit`;
}

export function getPathContactProfile(contactId) {
  return `/contact-profile/${contactId}`;
}

export function getPathContactProfileActivities(contactId, qs={}) {
  return urlUtils.appendQueryString(`/contact-profile-activities/${contactId}`, qs);
}

export function getPathContactProfileAssociations(contactId, qs={}) {
  return urlUtils.appendQueryString(`/contact-profile-associations/${contactId}`, qs);
}

export function getPathContactProfileOrders(contactId, qs={}) {
  return urlUtils.appendQueryString(`/contact-profile-orders/${contactId}`, qs);
}

export function getPathContactLists(qs={}) {
  return urlUtils.appendQueryString(`/contact-lists`, qs);
}

export function getPathContactTags(qs={}) {
  return urlUtils.appendQueryString(`/contact-tags`, qs);
}

export function getPathContactSegments(qs={}) {
  return urlUtils.appendQueryString(`/contact-segments`, qs);
}

export function getPathSegmentTemplates(qs={}) {
  return urlUtils.appendQueryString(`/segment-templates`, qs);
}

export function getPathAddContactSegment() {
  return `/contact-segments/add`;
}

export function getPathEditContactSegment(segmentId) {
  return `/contact-segments/${segmentId}/edit`;
}

export function getPathReplicateContactSegment(segmentId) {
  return `/contact-segments/${segmentId}/replicate`;
}

export function getPathCreateSegmentFromTemplate(templateId) {
  return `/contact-segments/${templateId}/create-from-template`;
}

// Activities
export function getPathOnVoardContactActivities(qs={}) {
  return urlUtils.appendQueryString(`/onvoard-contact-activities`, qs);
}

export function getPathExternalContactActivities(qs={}) {
  return urlUtils.appendQueryString(`/external-contact-activities`, qs);
}

export function getPathCustomContactActivities(qs={}) {
  return urlUtils.appendQueryString(`/custom-contact-activities`, qs);
}

// Properties
export function getPathPredefinedContactProperties(qs={}) {
  return urlUtils.appendQueryString(`/predefined-contact-properties`, qs);
}

export function getPathCustomContactProperties(qs={}) {
  return urlUtils.appendQueryString(`/custom-contact-properties`, qs);
}


// Bulk Actions
export function getPathContactsBulkActions(qs={}) {
  return urlUtils.appendQueryString(`/contacts-bulk-actions`, qs);
}

export function getPathAddContactsBulkAction() {
  return `/contacts-bulk-actions/add`;
}

export function getPathEditContactsBulkAction(bulkActionId) {
  return `/contacts-bulk-actions/${bulkActionId}/edit`;
}

export function getPathPreviewContactsBulkAction(bulkActionId) {
  return `/contacts-bulk-actions/${bulkActionId}/preview`;
}

export function getPathContactsBulkActionLogs(bulkActionId, qs={}) {
  return urlUtils.appendQueryString(`/contacts-bulk-actions/${bulkActionId}/logs`, qs);
}

function pathViewContactsBulkActionShforms(bulkActionId=null) {
  if (bulkActionId) {
      return `view/contacts-bulk-action-shforms/${bulkActionId}`;
  } else {
      return `view/contacts-bulk-action-shforms`;
  }
}

export function getViewContactsBulkActionShforms(successCallback, errorCallback, bulkActionId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewContactsBulkActionShforms(bulkActionId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}
